import { render, staticRenderFns } from "./RelatedMenu.vue?vue&type=template&id=47e8adfb&scoped=true&"
import script from "./RelatedMenu.vue?vue&type=script&lang=js&"
export * from "./RelatedMenu.vue?vue&type=script&lang=js&"
import style0 from "./RelatedMenu.vue?vue&type=style&index=0&id=47e8adfb&lang=scss&scoped=true&"
import style1 from "./RelatedMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e8adfb",
  null
  
)

export default component.exports